var map = {
	"./h5/banner.jpg": 318084,
	"./h5/banner_jp.jpg": 915196,
	"./h5/community.jpg": 521958,
	"./h5/share.jpg": 241339,
	"./pc/banner.jpg": 899498,
	"./pc/banner_jp.jpg": 468371,
	"./pc/blog/blog1.jpg": 305512,
	"./pc/blog/blog2.jpg": 830190,
	"./pc/blog/blog3.jpg": 756691,
	"./pc/blog/blog4.jpg": 656751,
	"./pc/community.jpg": 534144,
	"./pc/share.jpg": 537519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 863460;